 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import RECOMMENDATIONS from '@/components/recommendations'
 import TITLEPAGE from '@/components/title-page'
 import EBOOKCOPYRIGHT from '@/components/ebook-copyright'
 import CONTENTS from '@/components/contents'
 import FOREWORD from '@/components/foreword'
 import INTRODUCTION from '@/components/introduction'
 import CHAPTER001 from '@/components/chapter-001'
 import CHAPTER002 from '@/components/chapter-002'
 import CHAPTER003 from '@/components/chapter-003'
 import CHAPTER004 from '@/components/chapter-004'
 import CHAPTER005 from '@/components/chapter-005'
 import CHAPTER006 from '@/components/chapter-006'
 import CHAPTER007 from '@/components/chapter-007'
 import CHAPTER008 from '@/components/chapter-008'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import BEFOREYOUGO from '@/components/before-you-go'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js